"use client";

import { QueryProvider } from "@/components/QueryProvider";
import { createStore } from "jotai";
import { Provider as JotaiProvider } from "jotai/react";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren;

export const store: ReturnType<typeof createStore> = createStore();

export const Providers: FC<Props> = ({ children }) => {
  return (
    <QueryProvider>
      <JotaiProvider store={store}>
        <NuqsAdapter>{children}</NuqsAdapter>
      </JotaiProvider>
    </QueryProvider>
  );
};
